(() => {
  if (window.njtHeroPlaybackReady || !('IntersectionObserver' in window)) return;
  window.njtHeroPlaybackReady = true;
  const videos = new Map();
  const update = (video, visible) => {
    if (document.hidden || !visible) video.pause();
    else video.play()?.catch(() => {});
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      videos.set(entry.target, entry.isIntersecting);
      update(entry.target, entry.isIntersecting);
    });
  }, {threshold:0});
  const init = () => {
    videos.forEach((visible, video) => {
      if (!video.isConnected) {observer.unobserve(video); videos.delete(video);}
    });
    document.querySelectorAll('.new-hero-section__video video').forEach(video => {
      if (videos.has(video)) return;
      videos.set(video, false);
      video.playsInline = true;
      observer.observe(video);
    });
  };
  document.addEventListener('visibilitychange', () => videos.forEach((visible, video) => update(video, visible)));
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    videos.forEach((visible, video) => {
      if (event.target.contains(video)) {video.pause();observer.unobserve(video);videos.delete(video);}
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
